import { render, staticRenderFns } from "./BandeiraDiscover.vue?vue&type=template&id=70cb05bb&"
import script from "./BandeiraDiscover.vue?vue&type=script&lang=js&"
export * from "./BandeiraDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports